global.cookieHandler = (function ($) {
	'use strict';

	var siteCookie = $('.js-site-cookie');
	var acceptCookieBtn = $('.js-accept-cookies');
	var declineCookieBtn = $('.js-decline-cookies');
	var toggleTrackingBtn = $('.js-toggle-tracking');
	var toggleTrackingInput = document.querySelector('.js-toggle-tracking input');

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		var expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
	}

	function getCookie(cname) {
		var name = cname + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return '';
	}

	function deleteCookie(name) {
		setCookie(name, '', -1);
	}

	acceptCookieBtn.on('click',
		function (e) {
			e.preventDefault();
			enableTracking();
			setCookie('AnsweredCookies', 'true', 365);
			siteCookie.removeClass('is-visible');
			if (toggleTrackingInput) { toggleTrackingInput.checked = true; }
		});

	declineCookieBtn.on('click',
		function (e) {
			e.preventDefault();
			setCookie('AnsweredCookies', 'true', 365);
			disableTracking();
			siteCookie.removeClass('is-visible');
		});

	toggleTrackingBtn.on('change',
		function () {
			setCookie('AnsweredCookies', 'true', 365);
			siteCookie.removeClass('is-visible');

			if ($(this).find('input:checkbox').is(':checked')) {
				enableTracking();
			} else {
				disableTracking();
			}
		});

	function enableTracking() {
		deleteCookie('DisabledStatisticsCookies');
		if (window.$vizzit)
			window.$vizzit.cookie.set();
	}

	function disableTracking() {
		setCookie('DisabledStatisticsCookies', 'true', 365);
		deleteCookie('___vizzit');
	}

	function checkCookies() {
		var hasRespondedCookies = getCookie('AnsweredCookies');
		var userIsOnCookiePage = document.querySelector('.cookie-management-block') != null;

		if (!hasRespondedCookies) {
			siteCookie.addClass('is-visible');
		}

		if (userIsOnCookiePage) {
			siteCookie.addClass('minified');
		}
	}

	$(document)
		.ready(function () {
			checkCookies();
		});
	return {
		setCookie: setCookie,
		getCookie: getCookie,
		deleteCookie: deleteCookie
	};
})(jQuery);
